import { registerComponent } from "lib/components";
import { VersionNoteEditorApp } from "./main";

registerComponent({ VersionNoteEditorApp });
